import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SocialLink, SocialLinkService } from '@/models'

import { useInvalidateSocialLinks } from './get-social-links'

export type UpdateSocialLinkRequest = {
  id: number
  buildingId: number
  service: SocialLinkService
  link: string
}

export const updateSocialLink = async (data: UpdateSocialLinkRequest): Promise<SocialLink> => {
  const { id, ...body } = data
  const response = await authAPI.put<SocialLink>(`/sociallink/${id}`, body)
  return response.data
}

export const useUpdateSocialLink = () => {
  const invalidate = useInvalidateSocialLinks()

  return useMutation({
    mutationFn: updateSocialLink,
    onSuccess: invalidate,
  })
}
